<template>
  <div class="main">
    <el-row class="button" style="height: 40px;border-bottom: 1px solid rgba(41, 155, 255, .2);">
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="addProcess" @click="addProcess">
        新增流程
      </el-button>
    </el-row>
    <div class="linkage-list" style="height: calc(100% - 80px );overflow-y: auto">
      <ul class="ul list" v-if="processList.length > 0">
        <li v-for="item of processList" :key="item.id">
          <process-item @getActList="getActDeModelList"
                        @editProcess="editProcess"
                        :item="item">
          </process-item>
        </li>
      </ul>
      <no-tactics :name="'流程'"
                  style="text-align: center;margin-top: 8%"
                  @add="addProcess"
                  v-else></no-tactics>
    </div>
  </div>
</template>

<script>
import NoTactics from "@/components/NoTactics";
import ProcessItem from "@/views/basic_operations/strategy/process_engine/process/com/ProcessItem";
import {actDeModelList} from "@/network/act-de-model";

export default {
  name: "ProcessList",
  components: {NoTactics, ProcessItem},
  data() {
    return {
      processList: [],
    }
  },
  mounted() {
    this.getActDeModelList();
  },
  methods: {
    // 流程列表
    getActDeModelList() {
      actDeModelList().then(res => {
        if (res.code === 0) {
          this.processList = res.data
        }
      });
    },
    addProcess() {
      this.$router.push("/strategy/process/edit-process")
    },
    editProcess(data,copy ) {
      this.$router.push({path: '/strategy/process/edit-process', query: {id: data.id,copy: copy}});
    },
  },
}
</script>

<style scoped>
.main {
  padding: 15px 10px;
  overflow: auto;
}

/*分割线*/
.cross-line {
  width: 100%;
  margin-top: 10px;
  height: 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.5;
}

/*列表内容*/
.linkage-list {
  margin-top: 10px;
}

.linkage-list ul {
  padding: 0;
  list-style: none;
}

.linkage-list li {
  margin: 10px;
  float: left;
  list-style: none;
}
</style>
